/*
* @Author: jack
* @Date:   2019-12-17 12:26:06
* @Last Modified by:   jack
* @Last Modified time: 2019-12-24 15:16:41
*/
import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
export default new Router({
  // mode: 'history',
  base: '/app/resource/',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/pages/index'),
      meta: {
        requiresAuth: true,
        showBanner: true,
        title: '首页'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/login'),
      meta: {
        requiresAuth: false,
        title: '登录'
      }
    },
    {
      path: '/article',
      component: () => import('@/pages/article'),
      name: 'Article',
      meta: { title: '列表', showBanner: true, requiresAuth: true }
    },
    {
      path: '/article/info/:id',
      component: () => import('@/pages/articleInfo'),
      name: 'ArticleInfo',
      meta: { title: '内容', showBanner: true, requiresAuth: true }
    },
    {
      path: '/res',
      component: () => import('@/pages/res'),
      name: 'Res',
      meta: { title: '列表', showBanner: true, requiresAuth: true }
    },
    {
        path: '/add',
        component: () => import('@/pages/add'),
        name: 'AppResourceAdd',
        meta: { title: '我要上传', requiresAuth: true }
      },
      {
        path: '/info/:id',
        component: () => import('@/pages/info'),
        name: 'AppResourceInfo',
        meta: { title: '资源详情', requiresAuth: true }
      },
      {
        path: '/my',
        component: () => import('@/pages/my'),
        name: 'AppResourceMy',
        meta: { title: '我的资源', requiresAuth: true }
      },
      {
        path: '/person/:id',
        component: () => import('@/pages/my'),
        name: 'AppResourcePerson',
        meta: { title: '我的资源', requiresAuth: true }
      },
      {
        path: '/edit/:id',
        component: () => import('@/pages/edit'),
        name: 'AppResourceEdit',
        meta: { title: '編輯资源', requiresAuth: true }
      }
  ]
})
